import React, { useContext, useEffect, useMemo } from "react";
import { PromoContext } from "@context/PromoContext";
import { SessionContext } from "@context/SessionContext";
import RedemptionsBar from "@components/RedemptionDetails/RedemptionsBar";
import RedemptionsSelect from "@components/RedemptionDetails/RedemptionsSelect";
import { findPriorityPromo, filterPromoOptions, isAutoSelected } from "@utils/promoUtils";
import "./style.scss";

const RedemptionDetailsBase = ({ ticketClass = 0 }) => {
    const { promoOptions, handleSelectPromo } = useContext(PromoContext);
    const { session } = useContext(SessionContext);

    const mapOption = (item) => ({
        ...item,
        label: item.unique_code,
        value: item.promo_code_id,
    });

    const searchOptions = useMemo(
        () => (Array.isArray(promoOptions)
            ? filterPromoOptions(promoOptions, session).map(mapOption)
            : []),
        [promoOptions, session]
    );

    // Determines if there is only one valid promo option to display OR if there is a promo with capped purchases (which must be displayed).
    const autoDisplayOption = useMemo(
        () => findPriorityPromo(searchOptions),
        [searchOptions]
    );

    const autoSelectOption = useMemo(
        () => isAutoSelected(autoDisplayOption),
        [autoDisplayOption]
    );

    useEffect(() => {
        if (autoSelectOption) {
            handleSelectPromo(autoSelectOption);
        }
    }, [autoSelectOption, promoOptions]);

    if (searchOptions.length === 0) {
        return null;
    }

    return (
        <>
            {autoDisplayOption ? (
                <RedemptionsBar
                    promoDetails={autoDisplayOption}
                    ticketClass={ticketClass}
                />
            ) : (
                <RedemptionsSelect
                    ticketClass={ticketClass}
                    searchOptions={searchOptions}
                />
            )}
        </>
    );
};

export default RedemptionDetailsBase;
